<template>
  <el-upload :action="action" :style="{width: width}" :disabled="disabled" :limit="limit" :on-success="onSuccess" :file-list="list" :on-remove="onRemove">
    <el-button size="small" type="primary">{{$t('fm.actions.upload')}}</el-button>
    <div v-if="tip" class="el-upload__tip" slot="tip">{{tip}}</div>
  </el-upload>
</template>

<script>
export default {
  name: 'upload-file',
  props: {
    action: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 9
    },
    tip: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      list: this.value
    }
  },
  methods: {
    onSuccess(response, file, fileList) {
      if (response) {
        this.list.push({
          name: file.name,
          url: response.url,
          ...response
        })

        this.$emit('input', this.list)
      }
    },
    onRemove(file, fileList) {
      this.list = [...fileList]
      this.$emit('input', this.list)
    }
  },
  watch: {
    value(val) {
      this.list = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Upload/file.vue